import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import LazyTippy from './lazy_tippy'
import InvoiceMessagesInfo from './invoice_messages_info'
import StoragePredictionInfo from './storage_prediction_info'

function Tooltip({
  children,
  content,
  jsxContent = undefined,
  placement = 'top',
  disabled = false,
  className = '',
  invoiceMessageIds = undefined,
  contractMessageIds = undefined,
  storagePrediction = undefined,
  lazy = false,
  apiUrl = undefined,
  interactive = false
}) {
  if (((!content && !jsxContent) || disabled) && !invoiceMessageIds && !contractMessageIds && !storagePrediction) {
    return children
  }

  if (!jsxContent) {
    if (invoiceMessageIds) {
      jsxContent = <InvoiceMessagesInfo ids={invoiceMessageIds} apiUrl={apiUrl} />
    } else if (contractMessageIds) {
      jsxContent = <InvoiceMessagesInfo ids={contractMessageIds} apiUrl={apiUrl} type="contract" />
    } else if (storagePrediction) {
      jsxContent = <StoragePredictionInfo apiUrl={apiUrl} />
    } else {
      jsxContent = <div className={className} dangerouslySetInnerHTML={{ __html: content }}></div>
    }
  }

  if (lazy || invoiceMessageIds || storagePrediction) {
    return (
      <LazyTippy content={jsxContent} placement={placement}>
        {children}
      </LazyTippy>
    )
  }

  return (
    <Tippy content={jsxContent} placement={placement} interactive={interactive}>
      {children}
    </Tippy>
  )
}

export default Tooltip
